/** Pure logic of the "Additional Data" dialog: sizes split and reordering. */
import type { Product, ProductSize } from './api';

export interface Edited {
  product: Product;
  uniqueSize: ProductSize;
  sizes: ProductSize[];
}

/** A product with a unique size keeps it apart and empties the size rows. */
export const splitSizes = (product: Product): Edited => {
  if (product.hasUniqueSize) {
    return {
      product,
      uniqueSize: { ...(product.sizes?.[0] ?? {}), size: 'U', unique: true },
      sizes: [],
    };
  }
  return {
    product,
    uniqueSize: { size: 'U', unique: true },
    sizes: [...(product.sizes ?? [])],
  };
};

export const moveItem = <T>(
  list: readonly T[],
  from: number,
  to: number,
): T[] => {
  const next = [...list];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item as T);
  return next;
};
